class Field {
  constructor(
    editor,
    eid,
    field,
  ) {
    this.editor = editor;
    this.eid = eid;
    this.field = field;
  }

    htmlId = () => `${this.eid}-${this.field}`;

    getValues = () => {
      const metadata = this.getMetadata();
      return (this.editor.getValue(this.eid, this.field) || []).map((item) => {
        if (metadata.field_type === 'list_integer') {
          return item.value;
        } else if (metadata.field_type === 'entityreference') {
          return item.target_id;
        }
        return undefined;
      });
    }

    setValues = (values) => {
      const metadata = this.getMetadata();
      const fieldType = metadata && metadata.field_type;
      values = (values || []).map((v) => {
        if (fieldType === 'list_integer') {
          return { value: v };
        } else if (fieldType === 'entityreference') {
          return { target_id: v };
        }
        return undefined;
      });
      this.editor.setValue(this.eid, this.field, values);
    }

    getValue = () => {
      const values = this.editor.getValue(this.eid, this.field);
      const metadata = this.getMetadata();
      if (this.isSimpleType(metadata)) {
        return (values && values.length === 1) ? values[0].value : null;
      } else if (metadata.field_type === 'taxonomy_term_reference') {
        return (values && values.length === 1) ? values[0].tid : null;
      } else if (metadata.field_type === 'entityreference' && metadata.target_type === 'taxonomy_term') {
        return values;
      } else if (metadata.field_type === 'link_field') {
        return (values && values.length === 1) ? values[0].url : null;
      } else if (metadata.field_type === 'list_text') {
        return (values && values.length === 1) ? values[0] : null;
      } else {
        throw new Error(`Unsupported type: ${metadata.field_type}`);
      }
    }

    setValue = (value) => {
      const metadata = this.getMetadata();
      const fieldType = metadata && metadata.field_type;
      let values = null;
      if (fieldType === 'text') {
        values = (value === '' || value === null) ? [] : [{ value, format: null, safe_value: value }];
      } else if (fieldType === 'datestamp') {
        values = (value === '' || value === null) ? [] : [{
          value,
          timezone: 'America/New_York',
          timezone_db: 'America/New_York',
          date_type: 'datestamp',
        }];
      } else if (this.isSimpleType(metadata)) {
        values = (value === '' || value === null) ? [] : [{ value }];
      } else if (fieldType === 'taxonomy_term_reference') {
        values = (value === '' || value === null) ? [] : [{ tid: value }];
      } else if (fieldType === 'entityreference' && metadata.target_type === 'taxonomy_term') {
        values = (value === '' || value === null) ? [] : value;
      } else if (fieldType === 'link_field') {
        values = (value === null) ? [] : [{ url: value }];
      } else if (fieldType === 'list_text') {
        values = (value === '' || value === null) ? [] : [value];
      } else {
        throw new Error(`Unsupported type: ${fieldType}`);
      }
      this.editor.setValue(this.eid, this.field, values);
    }

    isSimpleType = (metadata) => {
      const fieldType = metadata && metadata.field_type;

      return fieldType === 'text' ||
        fieldType === 'text_long' ||
        fieldType === 'number_integer' ||
        fieldType === 'number_float' ||
        fieldType === 'list_integer' ||
        fieldType === 'list_boolean' ||
        fieldType === 'datestamp';
    }

    getMetadata = () => this.editor.getMetadata(this.eid, this.field);

    getType = () => this.getMetadata().field_type;

    getLabel = () => this.getMetadata().label;

    getAllowedValues = () => {
      if (!this.allowedValues) {
        const metadata = this.getMetadata();
        if (
          metadata.field_type === 'list_integer' ||
          metadata.field_type === 'list_boolean' ||
          metadata.field_type === 'taxonomy_term_reference' ||
          (metadata.field_type === 'entityreference' && metadata.target_type === 'taxonomy_term')
        ) {
          // (allowEmpty ? [{ id: null, label: '' }] : []).concat(
          this.allowedValues = Object.keys(metadata.allowed_values)
            .map((id) => ({ id, label: metadata.allowed_values[id] }))
            .sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));
        } else {
          throw new Error(`Unsupported type: ${metadata.field_type}`);
        }
      }

      return this.allowedValues;
    }

    getMaxLength = () => {
      const metadata = this.getMetadata();
      if (metadata.field_type === 'text') {
        return parseInt(metadata.field_length, 10);
      } else {
        throw new Error(`Unsupported type: ${metadata.field_type}`);
      }
    }
}

export default Field;
